import { render, staticRenderFns } from "./HistoricalUsage.vue?vue&type=template&id=75475e22&scoped=true&"
import script from "./HistoricalUsage.vue?vue&type=script&lang=js&"
export * from "./HistoricalUsage.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalUsage.vue?vue&type=style&index=0&id=75475e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75475e22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75475e22')) {
      api.createRecord('75475e22', component.options)
    } else {
      api.reload('75475e22', component.options)
    }
    module.hot.accept("./HistoricalUsage.vue?vue&type=template&id=75475e22&scoped=true&", function () {
      api.rerender('75475e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/billing/HistoricalUsage.vue"
export default component.exports